module.exports = __webpack_public_path__ + "img/lumeris-logo-white.b1ac3fa3.svg";